module.exports = __webpack_public_path__ + "static/img/news1.2014eeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/news1.png
// module id = UpjH
// module chunks = 2